function getImageUrls(images) {
  const imgSources = []
  for (const img of images) {
    imgSources.push(`./images/${img}`)
  }
  return imgSources
}

export { getImageUrls }
